<div class="container-fluid">
    <div>
        <div class="margin-top-8">
            <div class="container-header">
                Setup your bike sale communication
            </div>
            <div class="header">
                This is where you can setup communication to go out on the sale of different bike types. Using the
                product type, product category or product tags we will identify the product and send out communication
                based on the configuration below.
            </div>
            <br/>
            <div class="margin-top-8 info-container content">
                <p-progressSpinner *ngIf="saving" [style]="{ width: '30px', height: '30px' }" strokeWidth="2"
                                   fill="transparent"
                                   animationDuration=".5s"></p-progressSpinner>


                <div class="row margin-top-16">
                    <div class="col-md-4 label">
                        Bike Sale Type
                    </div>
                    <div class="col-md-8 value">
                        <input id="float-input" type="text" pInputText [(ngModel)]="bikeSaleItem.Type"/>
                    </div>
                </div>

                <div class="row margin-top-16">
                    <div class="col-md-4 label">
                        Product Type(s)
                    </div>
                    <div *ngIf="!loadingTypes" class="col-md-8 value">
                        <div class="margin-top-16" *ngIf="partner.POSSystemID === 9">
                            <input id="float-input" type="text" pInputText [(ngModel)]="type" (blur)="addType()"
                                   (keydown.enter)="addType()"/>
                        </div>
                        <div class="margin-top-16" *ngIf="partner.POSSystemID === 6 || partner.POSSystemID === 3">
                            <p-multiSelect [options]="productTypes" [(ngModel)]="selectedProductTypes"
                                           (onChange)="addType()" [filter]="true" [showToggleAll]="false"
                                           [maxSelectedLabels]="10" defaultLabel="{{selectedTypes}}"></p-multiSelect>
                        </div>
                        <div class="col-md-12 value">
                            <small *ngIf="bikeSaleItem.Type.length == 0">Add any product type/category that will help
                                identify a product</small>
                            <small *ngIf="bikeSaleItem.Type.length > 0">Add any product type/category that will help
                                identify a {{bikeSaleItem.Type}}</small>
                        </div>
                    </div>
                    <div *ngIf="loadingTypes" class="col-md-1 value">
                        <p-progressSpinner [style]="{ width: '30px', height: '30px' }" strokeWidth="2"
                                           fill="transparent"
                                           animationDuration=".5s"></p-progressSpinner>
                    </div>
                </div>


                <div *ngIf="partner.POSSystemID === 9" class="row margin-top-16">
                    <div class="col-md-12">
                        <div class="chip-container pull-right">
                            <div *ngFor="let item of bikeSaleItem.ProductTypes" class="chip">
                                <span>{{item}}</span><span class="fa fa-times" (click)="deleteType(item)"></span>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="row margin-top-16">
                    <div class="col-md-4 label">
                        Product Tag(s)
                    </div>
                    <div *ngIf="!loadingTags" class="col-md-8 value">
                        <div class="margin-top-16" *ngIf="partner.POSSystemID === 9">
                            <input id="float-input" type="text" pInputText [(ngModel)]="tag" (blur)="addTag()"
                                   (keydown.enter)="addTag()"/>
                        </div>
                        <div class="margin-top-16" *ngIf="partner.POSSystemID === 6 || partner.POSSystemID === 3">
                            <!--<p-dropdown [options]="productTags" [(ngModel)]="selectedProductTag" (onChange)="addTag()" filter="true"></p-dropdown>-->
                            <p-multiSelect [options]="productTags" [(ngModel)]="selectedProductTags"
                                           (onChange)="addTag()" [filter]="true" [showToggleAll]="false"
                                           [maxSelectedLabels]="10" defaultLabel="{{selectedTags}}"></p-multiSelect>
                        </div>
                        <div class="col-md-12 value">
                            <small *ngIf="bikeSaleItem.Type.length == 0">Add any product tags that will help identify a
                                product</small>
                            <small *ngIf="bikeSaleItem.Type.length > 0">Add any product tags that will help identify
                                a {{bikeSaleItem.Type}}</small>
                            <!--<small>{{ 'bikeshop.checklist.control_type_description' | translate }}</small>-->
                        </div>
                    </div>
                    <div *ngIf="loadingTags" class="col-md-1 value">
                        <p-progressSpinner [style]="{ width: '30px', height: '30px' }" strokeWidth="2"
                                           fill="transparent"
                                           animationDuration=".5s"></p-progressSpinner>
                    </div>
                </div>


                <div *ngIf="partner.POSSystemID === 9" class="row margin-top-16">
                    <div class="col-md-12">
                        <div class="chip-container pull-right">
                            <div *ngFor="let item of bikeSaleItem.ProductTags" class="chip">
                                <span>{{item}}</span><span class="fa fa-times" (click)="deleteTag(item)"></span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row margin-top-16">
                    <div class="col-md-4 label">
                        Linked message template
                    </div>
                    <div *ngIf="!loadingTemplates" class="col-md-8 value">
                        <p-dropdown [options]="messageTemplates" [(ngModel)]="selectedTemplate"
                                    placeholder="Select template"
                                    [disabled]="messageTemplates.length === 0"></p-dropdown>
                        <div class="col-md-12 value">
                            <small></small>
                            <small *ngIf="bikeSaleItem.Type.length == 0">This will be the email that gets sent out every
                                time a sale is identified</small>
                            <small *ngIf="bikeSaleItem.Type.length > 0">This will be the email that gets sent out every
                                time a {{bikeSaleItem.Type}} sale is identified</small>
                            <!--<small>{{ 'bikeshop.checklist.control_type_description' | translate }}</small>-->
                        </div>
                    </div>
                    <div *ngIf="loadingTemplates" class="col-md-1 value">
                        <p-progressSpinner [style]="{ width: '30px', height: '30px' }" strokeWidth="2"
                                           fill="transparent"
                                           animationDuration=".5s"></p-progressSpinner>
                    </div>
                </div>


                <div class="row margin-top-16">
                    <div class="col-md-4">
                        <button *ngIf="bikeSaleItemID>0"
                                pButton class="p-button-raised alternate full-width"
                                label="{{'bikeshop.general.delete' | translate}}" (click)="deleteBikeSale()"></button>
                    </div>
                    <div class="col-md-4"></div>
                    <div class="col-md-4">
                        <button pButton class="p-button-raised full-width" (click)="saveBikeSale()"
                                [disabled]="validate()"
                                label="{{'bikeshop.general.save' | translate}}"></button>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>
